import React, { useState,useRef } from 'react';
import './Form.css';
import styled from "styled-components";
import {
  ContactContainer,
  ContactH1,
  ContactWrapper,
  ContactCard,
  ContactIcon,
  ContactH2,
  ContactP1,
  ContactP2

} from './ContactElements';
const ContactFormV2 = () => {
  const form = useRef();

  const sendEmail = (e) => {



  };
  return (
    <StyledContactForm>
    <form ref={form} onSubmit={sendEmail}>
      <ContactP2>Name</ContactP2>
      <input type="text" name="user_name" />
      <ContactP2>Email</ContactP2>
      <input type="email" name="user_email" />
      <ContactP2>Message</ContactP2>
      <textarea name="message" />
      <input type="submit" value="Send" />
    </form>
  </StyledContactForm>
  );
};

export default ContactFormV2;

const StyledContactForm = styled.div`
  width: 400px;
  background-color:#101522;
  
  form {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    font-size: 16px;

    input {
      width: 100%;
      height: 35px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);

      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }

    textarea {
      max-width: 100%;
      min-width: 100%;
      width: 100%;
      max-height: 100px;
      min-height: 100px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);

      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }

    label {
      margin-top: 1rem;
    }

    input[type="submit"] {
      margin-top: 2rem;
      cursor: pointer;
      background: #01bf71;
      color: white;
      border: none;
    }
  }`;